import { render, staticRenderFns } from "./OrderHistoryList.vue?vue&type=template&id=730b7f2e&scoped=true"
import script from "./OrderHistoryList.vue?vue&type=script&lang=js"
export * from "./OrderHistoryList.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryList.vue?vue&type=style&index=0&id=730b7f2e&prod&lang=scss&scoped=true"
import style1 from "../../sass/partials/sidebar-submenu.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730b7f2e",
  null
  
)

export default component.exports